
const weeks = [
  {
    week: 'Week 1',
    label: '第1週',
    title: '無料診断・ヒアリング',
    color: 'emerald',
    icon: 'ri-search-eye-line',
    tasks: [
      { day: 'Day 1–2', text: '物件情報・写真をご送付' },
      { day: 'Day 2–3', text: 'AI＋専門家による収益シミュレーション作成' },
      { day: 'Day 4–5', text: '無料相談（オンライン60分）・プラン確定' },
      { day: 'Day 6–7', text: '契約書類の確認・ご署名' },
    ],
  },
  {
    week: 'Week 2',
    label: '第2週',
    title: '許可申請・準備',
    color: 'amber',
    icon: 'ri-file-text-line',
    tasks: [
      { day: 'Day 8–9', text: '住宅宿泊事業法の届出書類作成' },
      { day: 'Day 10', text: '消防・保健所への事前確認' },
      { day: 'Day 11–12', text: '届出申請（行政窓口）' },
      { day: 'Day 13–14', text: '室内整備・アメニティ手配' },
    ],
  },
  {
    week: 'Week 3',
    label: '第3週',
    title: 'OTA登録・撮影',
    color: 'sky',
    icon: 'ri-camera-line',
    tasks: [
      { day: 'Day 15–16', text: 'プロカメラマンによる物件撮影' },
      { day: 'Day 17–18', text: 'Airbnb・Booking.com・楽天STAY 一括登録' },
      { day: 'Day 19–20', text: '価格設定・ダイナミックプライシング設定' },
      { day: 'Day 21', text: 'テスト予約・最終チェック' },
    ],
  },
  {
    week: 'Week 4',
    label: '第4週',
    title: '開業・運営スタート',
    color: 'rose',
    icon: 'ri-rocket-2-line',
    tasks: [
      { day: 'Day 22–23', text: '初回ゲスト受け入れ・チェックイン対応' },
      { day: 'Day 24–25', text: '24時間ゲストサポート体制稼働' },
      { day: 'Day 26–27', text: '清掃・リネン交換フロー確立' },
      { day: 'Day 28', text: '初月レポート・収益振込スタート' },
    ],
  },
];

const colorMap: Record<string, {
  bg: string; border: string; text: string; iconBg: string;
  badge: string; dot: string; line: string; weekBg: string;
}> = {
  emerald: {
    bg: 'bg-emerald-50', border: 'border-emerald-200', text: 'text-emerald-600',
    iconBg: 'bg-emerald-500', badge: 'bg-emerald-100 text-emerald-700',
    dot: 'bg-emerald-400', line: 'bg-emerald-300', weekBg: 'bg-emerald-500',
  },
  amber: {
    bg: 'bg-amber-50', border: 'border-amber-200', text: 'text-amber-600',
    iconBg: 'bg-amber-500', badge: 'bg-amber-100 text-amber-700',
    dot: 'bg-amber-400', line: 'bg-amber-300', weekBg: 'bg-amber-500',
  },
  sky: {
    bg: 'bg-sky-50', border: 'border-sky-200', text: 'text-sky-600',
    iconBg: 'bg-sky-500', badge: 'bg-sky-100 text-sky-700',
    dot: 'bg-sky-400', line: 'bg-sky-300', weekBg: 'bg-sky-500',
  },
  rose: {
    bg: 'bg-rose-50', border: 'border-rose-200', text: 'text-rose-600',
    iconBg: 'bg-rose-500', badge: 'bg-rose-100 text-rose-700',
    dot: 'bg-rose-400', line: 'bg-rose-300', weekBg: 'bg-rose-500',
  },
};

function TimelineSection() {
  return (
    <section className="py-20 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">

        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-slate-100 text-slate-600 rounded-full text-sm font-medium mb-5">
            <i className="ri-calendar-schedule-line"></i>
            開業までのスケジュール
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-4 tracking-tight">
            最短<span className="text-emerald-500">4週間</span>で開業完了
          </h2>
          <p className="text-lg text-slate-500 max-w-2xl mx-auto leading-relaxed">
            診断から収益振込まで、週単位の具体的なスケジュールをご確認いただけます。<br />
            すべての工程をプロが並走するので、オーナー様の負担はほぼゼロです。
          </p>
        </div>

        {/* Timeline grid */}
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-0 relative">

          {/* Horizontal connector (desktop) */}
          <div className="hidden lg:block absolute top-10 left-[12.5%] right-[12.5%] h-0.5 bg-gradient-to-r from-emerald-300 via-amber-300 via-sky-300 to-rose-300 z-0"></div>

          {weeks.map((week, index) => {
            const c = colorMap[week.color];
            return (
              <div key={week.week} className="relative flex flex-col items-center px-3">

                {/* Circle icon */}
                <div className={`relative z-10 w-20 h-20 flex items-center justify-center rounded-full ${c.iconBg} shadow-lg mb-5 flex-shrink-0`}>
                  <i className={`${week.icon} text-2xl text-white`}></i>
                  <span className="absolute -top-2 -right-2 w-7 h-7 flex items-center justify-center bg-white border-2 border-slate-200 rounded-full text-xs font-bold text-slate-700 shadow-sm">
                    {index + 1}
                  </span>
                </div>

                {/* Week badge */}
                <span className={`text-xs font-bold tracking-widest px-3 py-1 rounded-full mb-2 ${c.badge}`}>
                  {week.week}
                </span>

                {/* Card */}
                <div className={`w-full rounded-2xl border ${c.border} ${c.bg} p-5 shadow-sm hover:shadow-md transition-shadow duration-300`}>
                  <h3 className={`text-base font-bold text-slate-900 mb-4 pb-3 border-b ${c.border}`}>
                    {week.title}
                  </h3>
                  <ul className="space-y-3">
                    {week.tasks.map((task) => (
                      <li key={task.day} className="flex flex-col gap-0.5">
                        <span className={`text-xs font-semibold ${c.text}`}>{task.day}</span>
                        <span className="text-sm text-slate-700 leading-snug flex items-start gap-1.5">
                          <span className={`mt-1.5 w-1.5 h-1.5 rounded-full flex-shrink-0 ${c.dot}`}></span>
                          {task.text}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Arrow between (mobile) */}
                {index < weeks.length - 1 && (
                  <div className="lg:hidden mt-4 mb-2 text-slate-300">
                    <i className="ri-arrow-down-line text-2xl"></i>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/* Bottom note */}
        <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-6 text-sm text-slate-500">
          <div className="flex items-center gap-2">
            <i className="ri-information-line text-emerald-500"></i>
            <span>物件の状況により前後する場合があります</span>
          </div>
          <div className="hidden sm:block w-px h-4 bg-slate-200"></div>
          <div className="flex items-center gap-2">
            <i className="ri-shield-check-line text-emerald-500"></i>
            <span>許可申請から開業まで全工程を代行</span>
          </div>
          <div className="hidden sm:block w-px h-4 bg-slate-200"></div>
          <div className="flex items-center gap-2">
            <i className="ri-customer-service-2-line text-emerald-500"></i>
            <span>専任担当者が週次で進捗報告</span>
          </div>
        </div>

      </div>
    </section>
  );
}

export default TimelineSection;
